import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CustomerArrayModel, CustomerModel } from "../../models/CustomerModel";

const initialCustomerState: CustomerArrayModel = {
  all_Customers: [],
  particular_Customer: {
    customerId: 0,
    name: "",
    description: "",
    customerTypeId: 0,
    isActive: false,
  },
  isCustomersFetching: false,
};
const CustomerSlice = createSlice({
  name: "Customer",
  initialState: initialCustomerState,
  reducers: {
    setCustomers(state, action: PayloadAction<CustomerModel[]>) {
      state.all_Customers = action.payload;
    },
    setParticularCustomer(state, action: PayloadAction<CustomerModel>) {
      state.particular_Customer = action.payload;
    },
    setIsCustomersFetching(state, action: PayloadAction<boolean>) {
      state.isCustomersFetching = action.payload;
    },
  },
});
export default CustomerSlice;
